// Animated "neural core" status glyph — two counter-spinning dashed rings around a
// pulsing diamond core. Used for status-update cards + dialogs under the cyberpunk
// theme (replaces the plain refresh arrow). Colour follows currentColor.
export default function NeuralCore({ size = 22 }) {
  return (
    <svg className="neural-core" width={size} height={size} viewBox="0 0 24 24"
         fill="none" stroke="currentColor" strokeLinecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" strokeWidth="1.8" strokeDasharray="16 40"
              style={{ transformBox: "fill-box", transformOrigin: "center", animation: "tmc-spin 2.2s linear infinite" }} />
      <circle cx="12" cy="12" r="5.5" strokeWidth="1.5" strokeDasharray="9 24"
              style={{ transformBox: "fill-box", transformOrigin: "center", animation: "tmc-spinrev 3s linear infinite", opacity: 0.6 }} />
      <path d="M12 8.4 L15.6 12 L12 15.6 L8.4 12 Z" strokeWidth="1.6"
            style={{ transformBox: "fill-box", transformOrigin: "center", animation: "tmc-corepulse 1.6s ease-in-out infinite" }} />
    </svg>
  );
}
